import { Box, BoxProps } from '@mui/material';
import React, { Suspense, useCallback, useEffect, useState } from 'react';

import type { Props as MapContainerUIProps } from './MapContainer.ui';

const MapContainerUI = React.lazy(() => import('./MapContainer.ui'));
const MapContainerLOADING = React.lazy(() => import('./MapContainer.loading'));

interface MapContainerProps extends MapContainerUIProps {
  containerProps?: BoxProps;
  loading?: boolean;
}

/**
 * Map Component
 */
export const MapContainer: React.FC<MapContainerProps> = ({
  children,
  loading,
  containerProps = {},
  style: mapStyle = {},
  ...props
}) => {
  const [hasWindow, setWindow] = useState(false);
  const [aspectRatioXS, setAspectRatioXS] = useState({ width: 16, height: 9 });

  useEffect(() => {
    setWindow(typeof window !== 'undefined');
  }, []);

  const handleMapClick = useCallback(() => {
    if (aspectRatioXS.width != 1 || aspectRatioXS.height != 1) {
      setAspectRatioXS({ width: 1, height: 1 });
    }
  }, [aspectRatioXS]);

  return (
    <Box
      {...containerProps}
      sx={{
        position: 'relative',
        ...(containerProps.sx || {}),
        aspectRatio: {
          xs: `${aspectRatioXS.width}/${aspectRatioXS.height}`,
          md: `16/9`,
          lg: `1/1`,
        },
      }}
      onClick={handleMapClick}
    >
      <Suspense fallback="Loading (MapContainer)">
        {hasWindow ? (
          <MapContainerUI {...props} style={loading ? { ...mapStyle, zIndex: 0 } : mapStyle}>
            {children}
          </MapContainerUI>
        ) : null}

        {loading && hasWindow ? <MapContainerLOADING /> : null}

        {!hasWindow ? 'Loading (MapContainer)' : null}
      </Suspense>
    </Box>
  );
};
